"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultVideoCaptureAndEncodeParameter = /*#__PURE__*/function () {
  function DefaultVideoCaptureAndEncodeParameter(cameraWidth, cameraHeight, cameraFrameRate, maxEncodeBitrateKbps, isSimulcast) {
    var scaleResolutionDownBy = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;

    _classCallCheck(this, DefaultVideoCaptureAndEncodeParameter);

    this.cameraWidth = cameraWidth;
    this.cameraHeight = cameraHeight;
    this.cameraFrameRate = cameraFrameRate;
    this.maxEncodeBitrateKbps = maxEncodeBitrateKbps;
    this.isSimulcast = isSimulcast;
    this.scaleResolutionDownBy = scaleResolutionDownBy;
  }

  _createClass(DefaultVideoCaptureAndEncodeParameter, [{
    key: "equal",
    value: function equal(other) {
      var checkForEqual = other.captureWidth() === this.cameraWidth && other.captureHeight() === this.cameraHeight && other.captureFrameRate() === this.cameraFrameRate && other.encodeBitrates().length === this.encodeBitrates().length && other.encodeScaleResolutionDownBy().length === this.encodeScaleResolutionDownBy().length && other.encodeWidths().length === this.encodeWidths().length && other.encodeHeights().length === this.encodeHeights().length;

      if (checkForEqual) {
        for (var i = 0; i < other.encodeWidths().length; i++) {
          if (other.encodeWidths()[i] !== this.encodeWidths()[i] || other.encodeHeights()[i] !== this.encodeHeights()[i] || other.encodeBitrates()[i] !== this.encodeBitrates()[i] || other.encodeScaleResolutionDownBy()[i] !== this.encodeScaleResolutionDownBy()[i]) {
            checkForEqual = false;
            return checkForEqual;
          }
        }
      }

      return checkForEqual;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new DefaultVideoCaptureAndEncodeParameter(this.cameraWidth, this.cameraHeight, this.cameraFrameRate, this.maxEncodeBitrateKbps, this.isSimulcast, this.scaleResolutionDownBy);
    }
  }, {
    key: "captureWidth",
    value: function captureWidth() {
      return this.cameraWidth;
    }
  }, {
    key: "captureHeight",
    value: function captureHeight() {
      return this.cameraHeight;
    }
  }, {
    key: "captureFrameRate",
    value: function captureFrameRate() {
      return this.cameraFrameRate;
    }
  }, {
    key: "encodeBitrates",
    value: function encodeBitrates() {
      // TODO: add simulcast layer
      return [this.maxEncodeBitrateKbps];
    }
  }, {
    key: "encodeScaleResolutionDownBy",
    value: function encodeScaleResolutionDownBy() {
      return [this.scaleResolutionDownBy];
    }
  }, {
    key: "encodeWidths",
    value: function encodeWidths() {
      return [this.cameraWidth];
    }
  }, {
    key: "encodeHeights",
    value: function encodeHeights() {
      return [this.cameraHeight];
    }
  }]);

  return DefaultVideoCaptureAndEncodeParameter;
}();

exports.default = DefaultVideoCaptureAndEncodeParameter;